<template>
  <div class="audit-result">
    <!-- 审核中 -->
    <div class="audit" v-if="detailData.status === 0">
      <div class="audit-bg">
        <img :src="require('@/assets/audit_bg.jpg')" />
      </div>
      <div class="title">请等待审核</div>
      <div class="tips">预计需要1-3工作日审核完毕</div>
      <van-button type="default" to="/activity/edit">修改活动信息</van-button>
    </div>
    <!-- 审核失败 -->
    <div class="fail" v-if="detailData.status === 2">
      <div class="audit-bg">
        <img :src="require('@/assets/fail_bg.jpg')" />
      </div>
      <div class="title">抱歉,您的活动申请未通过</div>
      <div class="tips">{{ detailData.auditOpinion }}</div>
      <van-button type="default" to="/activity/edit">修改活动信息</van-button>
    </div>
  </div>
</template>

<script>
import { activityDetail } from "@/api/activity";

export default {
  data() {
    return {
      detailData: {}
    };
  },
  mounted() {
    this.handleActivityDetail();
  },
  methods: {
    // 活动详情
    handleActivityDetail() {
      activityDetail(this.$route.query.id).then(res => {
        // console.log("活动详情 :>> ", res);
        for (let i = 0; i < res.serviceItems.length; i++) {
          let { itemName, quantity, unitPrice, unit } = res.serviceItems[i];
          let tempVal = {
            itemName: itemName,
            unitPrice: unitPrice / 100,
            quantity: quantity,
            unit: unit
          };
          res.serviceItems[i] = tempVal;
        }
        res.price /= 100;
        res.startTime = res.startTime.slice(0, 10);
        res.endTime = res.endTime.slice(0, 10);
        res.activateStartTime = res.activateStartTime.slice(0, 10);
        res.activateEndTime = res.activateEndTime.slice(0, 10);
        localStorage.setItem("editData", JSON.stringify(res));
        this.detailData = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.audit-result {
  .audit,
  .fail {
    .audit-bg {
      img {
        width: 100%;
      }
    }
    .title {
      margin-bottom: 15px;
      font-size: 20px;
    }
    .tips {
      margin-bottom: 50px;
      font-size: 16px;
    }
  }
}
</style>
